import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { map, switchMap, take } from 'rxjs';
import { RightsService } from '../../shared/services/rights.service';
import { TenantAccessService } from '../../shared/services/tenant-access.service';
import { Rights } from '../models/rights';

export const rightsGuard = (right: keyof Rights) => {
    return (route: ActivatedRouteSnapshot) => {
        const rightsService = inject(RightsService);
        const tenantAccess = inject(TenantAccessService);
        const router = inject(Router);

        const tenant = route.parent.params.tenant;

        if (tenantAccess.getTenantAccessSnapshot()) {
            return rightsService.getRightsOfCurrentUser().pipe(
                take(1),
                map((rights) => rights[right] ?? router.createUrlTree([tenant, 'prompts'])),
            );
        } else {
            return tenantAccess.loadTenantAccess(tenant).pipe(
                switchMap(() =>
                    rightsService.getRightsOfCurrentUser().pipe(
                        take(1),
                        map((rights) => rights[right] ?? router.createUrlTree([tenant, 'prompts'])),
                    ),
                ),
            );
        }
    };
};
